import Axios from "@app/api/axios";

import { CANDIDATE_API } from "@utils/constant";

export const getConsentDetailsService = (consentId = "") => {
  const candidateToken = localStorage.getItem("candidateToken");

  return Axios.get(`${CANDIDATE_API}/${consentId}`, {
    headers: { Authorization: `Bearer ${candidateToken}` },
  });
};
